var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChevronRightBlack = function SvgChevronRightBlack(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 8,
    height: 10,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M4.75 5 .917 1.167 2.084 0l5 5-5 5L.917 8.833z"
  })));
};
export { SvgChevronRightBlack as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI4IiBoZWlnaHQ9IjEwIiB2aWV3Qm94PSIwIDAgOCAxMCIgZmlsbD0ibm9uZSI+DQogIDxwYXRoIGQ9Ik00Ljc1MDMzIDVMMC45MTY5OTIgMS4xNjY2N0wyLjA4MzY2IDBMNy4wODM2NiA1TDIuMDgzNjYgMTBMMC45MTY5OTIgOC44MzMzM0w0Ljc1MDMzIDVaIiBmaWxsPSJibGFjayIvPg0KPC9zdmc+";